import classNames from 'classnames';
import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import styles from './select-option-card.module.scss';

export interface SelectOptionCardProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline: string;
  /** The icon to show in the card*/
  icon?: IconName;
  /** Indicates whether the field is selected */
  isSelected?: boolean;
  /** An event that is triggered on click */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /** The text to show as a description */
  text?: string;
}

const SelectOptionCard = ({
  className,
  headline,
  icon,
  isSelected = false,
  text,
  ...rest
}: SelectOptionCardProps) => {
  return (
    <button
      {...rest}
      className={classNames(styles.component, className, {
        [styles.isSelected]: isSelected,
      })}
      tabIndex={0}
    >
      {icon && <Icon className={styles.icon} name={icon} size={16} />}

      <div className={styles.content}>
        <Typography tag="label" tagStyle="bodyMediumBold">
          {headline}
        </Typography>

        {text && (
          <Typography className={styles.text} tag="p" tagStyle="bodyMedium">
            {text}
          </Typography>
        )}
      </div>
    </button>
  );
};

SelectOptionCard.displayName = 'SelectOptionCard';

export default SelectOptionCard;
